export type PermissionKey =
  | 'page.admin'
  | 'page.management.products'
  | 'page.management.allergens'
  | 'page.management.product-categories'
  | 'page.management.suppliers'
  | 'page.management.semi-finished'
  | 'page.management.semi-finished-production'
  | 'page.management.dishes'
  | 'page.management.inventory'
  | 'page.management.event-venues'
  | 'page.management.additional-services'
  | 'page.management.event-orders'
  | 'page.management.hotel'
  | 'page.management.inventory-receipts'
  | 'page.management.inventory-balance'
  | 'page.management.inventory-transfers'
  | 'page.management.inventory-write-offs'
  | 'page.management.inventory-nutrition'
  | 'page.management.inventory-resort'
  | 'page.management.employees'
  | 'page.management.employee-dossiers'
  | 'page.management.purchase-worksheet'
  | 'page.management.preparation-worksheets'
  | 'page.management.preparation-operations'
  | 'page.management.inventory-revisions'
  | 'page.management.kitchenware'
  | 'page.management.purchases'
  | 'page.management.qr'
  | 'page.management.salary'
  | 'page.management.halls-payroll'
  | 'page.management.schedule'
  | 'page.analytics.venues'
  | 'action.print'
  | 'action.edit'
  | 'action.view'
  | 'action.import'
  | 'action.export';

export const PAGE_PERMISSION_KEYS: ReadonlyArray<{ path: string; key: PermissionKey }> = [
  { path: '/admin', key: 'page.admin' },
  { path: '/admin/employees', key: 'page.admin' },
  { path: '/admin/audit-logs', key: 'page.admin' },
  { path: '/management/products', key: 'page.management.products' },
  { path: '/management/nutrition-base', key: 'page.management.products' },
  { path: '/management/allergens', key: 'page.management.allergens' },
  { path: '/management/product-categories', key: 'page.management.product-categories' },
  { path: '/management/suppliers', key: 'page.management.suppliers' },
  { path: '/management/semi-finished', key: 'page.management.semi-finished' },
  { path: '/management/semi-finished-production', key: 'page.management.semi-finished' },
  { path: '/management/dishes', key: 'page.management.dishes' },
  { path: '/management/sale-catalog', key: 'page.admin' },
  { path: '/management/inventory', key: 'page.management.inventory' },
  { path: '/management/inventory-activity', key: 'page.management.inventory' },
  { path: '/management/event-venues', key: 'page.management.event-venues' },
  { path: '/management/venue-bookings', key: 'page.management.event-venues' },
  { path: '/management/additional-services', key: 'page.management.additional-services' },
  { path: '/management/event-orders', key: 'page.management.event-orders' },
  { path: '/management/hotel', key: 'page.management.hotel' },
  { path: '/management/customers', key: 'page.management.event-orders' },
  { path: '/management/crm-dashboard', key: 'page.management.event-orders' },
  { path: '/management/inventory-receipts', key: 'page.management.inventory-receipts' },
  { path: '/management/inventory-balance', key: 'page.management.inventory-balance' },
  { path: '/management/inventory-transfers', key: 'page.management.inventory-transfers' },
  { path: '/management/inventory-warehouse-transfers', key: 'page.management.inventory-transfers' },
  { path: '/management/inventory-write-offs', key: 'page.management.inventory-write-offs' },
  { path: '/management/inventory-nutrition', key: 'page.management.inventory-nutrition' },
  { path: '/management/inventory-resort', key: 'page.management.inventory-resort' },
  { path: '/management/employees', key: 'page.admin' },
  { path: '/management/halls-payroll', key: 'page.management.halls-payroll' },
  { path: '/management/salary-payroll', key: 'page.management.salary' },
  { path: '/management/restaurant-payroll', key: 'page.management.salary' },
  { path: '/management/purchase-worksheet', key: 'page.management.purchase-worksheet' },
  { path: '/management/purchase-planning', key: 'page.management.purchase-worksheet' },
  { path: '/management/order-supply', key: 'page.management.event-orders' },
  { path: '/management/supplier-purchase-orders', key: 'page.management.purchase-worksheet' },
  { path: '/management/preparation-worksheets', key: 'page.management.preparation-worksheets' },
  { path: '/management/preparation-operations', key: 'page.management.preparation-operations' },
  { path: '/management/inventory-revisions', key: 'page.management.inventory-revisions' },
  { path: '/management/export-import', key: 'action.import' },
  { path: '/management/kitchenware', key: 'page.management.kitchenware' },
  { path: '/analytics/venues', key: 'page.analytics.venues' },
  { path: '/analytics/event-finance', key: 'page.management.event-orders' },
  { path: '/analytics/procurement-finance', key: 'page.management.purchase-worksheet' },
  { path: '/management/supplier-payment-batches', key: 'page.management.purchase-worksheet' },
  { path: '/management/accounting-periods', key: 'page.admin' },
];

const PAGE_PERMISSION_BY_PATH = new Map(PAGE_PERMISSION_KEYS.map(({ path, key }) => [path, key]));

export const getPagePermission = (path: string): PermissionKey | undefined =>
  PAGE_PERMISSION_BY_PATH.get(path);
